export default __webpack_public_path__ + "components/weather-icon/static/daymodsnow@2-8afd4710a924aa5c18b596622dba6d07.png";